export default "__VITE_ASSET__DKOmMF1o__"